/* eslint-disable camelcase */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { FormProvider, useForm, useFieldArray } from 'react-hook-form';
import { Row, Col, FormGroup } from 'react-bootstrap';
import Select from 'react-select';
import { isEmpty, isEqual } from 'lodash';
import { useParams, useHistory, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import './SupplierSuggestion.css';
import { useTranslation } from 'react-i18next';
import { MultiSelect } from 'react-multi-select-component';
import BomTypeForm from './Module/Bom/BomTypeForm';
import Loader from '../../Components/Utility/Loader/Loader';
import TestingSuggestion from './Module/Testing/TestingSuggestion';
import MeasurementsSuggestion from './Module/Measurement/MeasurementForm';
import CareLabelsForm from './Module/CareLabels/CareLabelsForm';
import { checkArray, createOptions, getYears, hasDuplicates, monthsPlaceholder, shortenStringWithTooltip, RightsAccess } from '../../Components/helper';
import { toasterMsg } from '../../Components/Toaster/Toaster';
import noImage from '../../assets/images/no-image.png';
import * as Action from './store/SupplierSuggestion.action';
import { getSeasonsDetails, fetchTestTypeMaster, getBomCustomAttribute } from '../SystemMasters/Store/SystemMasters.action';
import * as careLabelAction from '../DevlopmentOrder/CareLabels/store/CARELABEL.action';
import { useSuggestionProvider } from './Provider/SuggestionProvider';
import CustomTooltip from '../../Components/Tooltip/CustomTooltip';
import ProductTypeForm from './Module/ProductInformation/ProductTypeForm';
import * as devOrderAction from '../DevlopmentOrder/store/DevelopmentOrder.action';
import * as supplierAction from '../Supplier/store/Supplier.action';
import { fetchSupplier } from '../DevlopmentOrder/Bom/store/BOMConfig.action';
import { CurrentYearOption } from '../../Components/Utility/CurrentYearDropdown';

function SupplierSuggestion() {
  const history = useHistory();
  const dispatch = useDispatch();
  const reduxState = useSelector((reducerstate) => reducerstate);
  const { TestingRight } = RightsAccess();
  const [seasonOptions, setSeasonOptions] = useState([]);
  const [state, setState] = useState({
    clonedBomData: null,
    season: null,
    month: null,
    year: null,
  });
  const [gradingGroupsOptions, setGradingGroupsOptions] = useState([]);
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [selectedGrading, setSelectedGrading] = useState(null);
  const careLabel = 'care-label';
  const { careTabs, setCareTabs, submitValidate, ids, setUserState } = useSuggestionProvider();
  const [editedSupplierFactory, setEditedSupplierFactory] = useState({});

  const { clonedBomData } = state;
  const {
    SupplierSuggestion: { section, BOMComponent, BomType, TestingLibraries, MeasurementSuggestion },
    UserDetails: { userInfo },
    CareLabelProductReducer: { careList },
    Measuremets: { editedDevOrderData },
    SystemMastersDetails: { customAttributeBomList },
    SuppliersDetails: { tier1Suppliers },
  } = reduxState;

  useEffect(() => {
    if (BOMComponent[0]?.dynamicColumn) {
      setState((prevState) => ({
        ...prevState,
        clonedBomData: {
          ...prevState.clonedBomData,
          dynamicColumn: BOMComponent[0]?.dynamicColumn,
        },
      }));
    }
  }, [BOMComponent[0]]);

  useEffect(() => {
    const init = async () => {
      const seasonRes = await dispatch(
        getSeasonsDetails({
          loggedInUserId: userInfo?.userId,
        }),
      );
      const optList = createOptions(seasonRes, 'name', '_id');
      setSeasonOptions(optList);
      dispatch(fetchTestTypeMaster());
    };
    init();
  }, []);

  useEffect(() => {
    if (tier1Suppliers?.length > 0) {
      const localSupplierList = tier1Suppliers?.filter((item) => item?.name === 'Locally Sourced');
      localSupplierList.push({
        name: `${userInfo?.firstName} ${userInfo?.lastName}`,
        _id: userInfo.userId,
      });
      setSupplierOptions(localSupplierList);
    }
  }, [tier1Suppliers]);

  useEffect(() => {
    dispatch(getBomCustomAttribute());
  }, [BOMComponent, dispatch]);

  const productRefFromReducer = reduxState.SupplierSuggestion.productRef;

  const { t } = useTranslation('common');
  const {
    control,
    register,
    handleSubmit,
    getValues,
    reset,
    formState: { errors, isValid },
    setValue,
    clearErrors,
    trigger,
    watch,
  } = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
  });

  const defaultCompositionValue = [
    {
      percentage: null,
      composition: null,
    },
  ];

  const getDefaultDynamicColumns = (bomTypeId) => {
    if (!bomTypeId || !customAttributeBomList || !Array.isArray(customAttributeBomList)) {
      return [];
    }

    return customAttributeBomList
      .filter((item) => item?.bomTypeID === bomTypeId)
      .map((item) => ({
        colId: item,
        valueId: item.type === 'Multi Dropdown' ? [] : null,
        valueText: item.type === 'text' ? '' : null,
        optionsValue: item.type === 'Multi Dropdown' ? [] : null,
      }));
  };

  const { suggId, activeSection } = useParams();

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'bomForm',
  });

  const [editedPomLibraries, setEditedPomLibraries] = useState([]);
  const [editedSpecPomLibraries, setEditedSpecPomLibraries] = useState([]);
  const [oldMeasurmentData, setOldMeasurmentData] = useState([]);
  const { fields: testLibrariesArray, append: testLibrariesAppend, remove: testLibrariesRemove } = useFieldArray({ control, name: 'testLibraries' });

  const {
    fields: specPomLibrariesFields,
    append: specPomLibrariesAppend,
    remove: specPomLibrarieRemove,
    update: specPomUpdateLibraries,
    insert: specPomLibrarieInsert,
  } = useFieldArray({ control, name: 'specPomLibraries' });

  const {
    fields: pomLibrariesFields,
    append: pomLibrariesAppend,
    remove: pomLibrariesRemove,
    update: pomUpdateLibraries,
    insert: pomLibrariesInsert,
    replace: pomLibrariesreplace,
  } = useFieldArray({ control, name: 'pomLibraries' });

  const { fields: careSymbolFields, append: careSymbolAppend, remove: careSymbolRemove } = useFieldArray({ control, name: 'symbol' });

  const { fields: careInstructionFields, append: careInstructionAppend, remove: careInstructionRemove } = useFieldArray({ control, name: 'instruction' });

  const { fields: careDisclaimerFields, append: careDisclaimerAppend, remove: careDisclaimerRemove } = useFieldArray({ control, name: 'disclaimer' });

  const [formField, setFormField] = useState({
    section: false,
    type: true,
    proRef: true,
    bomType: true,
    bomComponent: true,
    testinglibrary: true,
    proRefMultiSelect: true,
    proRefSelect: true,
  });

  const [showHideField, setShowHideField] = useState({
    section: false,
    type: false,
    bomComponent: false,
    showTestingLibraryDropDown: false,
  });

  const [showHideFormBySectionLabel, setShowHideFormBySectionLabel] = useState({
    measurements: false,
    testing: false,
    careLabels: false,
    tradeReferences: false,
    productInformation: false,
  });
  const [showHideFormByProductInformation, setShowHideFormByProductInformation] = useState({
    productInformation: false,
  });

  const [productRef, setProductRef] = useState([]);
  const [currentSection, setCurrentSection] = useState('');
  const [componentType, setComponentType] = useState(null);
  const [productRefData, setProductRefData] = useState([]);
  const [bomComponentData, setBomComponentData] = useState([]);
  const [bomComponentForm, setBomComponentForm] = useState([]);
  const [selectedType, setSelectedType] = useState(null);
  const [selectedSection, setSelectedSection] = useState(null);
  const [sectionList, setSectionList] = useState([]);
  const [selectedBomType, setSelectedBomType] = useState(null);
  const [bomTypeList, setBomTypeList] = useState(null);
  const [selectedBomComponent, setSelectedBomComponent] = useState([]);
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [isCalledCompositionAndUnitSupplier, setIsCalledCompositionAndUnitSupplier] = useState(false);
  const [loader, setLoader] = useState(false);
  const [commentCount, setCommentCount] = useState(0);
  const [testinglibraryOptions, setTestinglibraryOptions] = useState([]);
  const [selectedTestinglibrary, setSelectedTestinglibrary] = useState([]);
  const [measurementSuggestion, setMeasurementSuggestion] = useState([]);
  const [sectionPermission, setSectionPermission] = useState([]);
  const [clearImage, setClearImage] = useState(true);
  const [origanalMeasurmentData, setOriganalMeasurmentData] = useState([]);
  const [suggestionEditMode, setSuggestionEditMode] = useState(false);
  const [measurementEditMode, setMeasurementEditMode] = useState(false);
  const [careLabelEditMode, setCareLabelEditMode] = useState(false);
  const [productRefBlank, setProductRefBlank] = useState(false);
  const [conversationData, setConversationData] = useState({
    conversionType: '',
    fraction: '',
  });

  const [hideGradings, setHideGradings] = useState([]);
  const [showGrading, setShowGrading] = useState(false);

  // LogedIn User ID
  const loggedInUserId = userInfo.userId;

  const typeOptions = [
    { value: 'amendment', label: 'Amendment' },
    { value: 'new', label: 'New' },
  ];

  const sectionOptionsArray = TestingRight
    ? [
        { value: 'bom', label: 'Bill of Materials' },
        { value: 'testing', label: 'Testing' },
        { value: 'measurement', label: 'Measurements' },
        { value: careLabel, label: 'Care Labels' },
        { value: 'product-information', label: 'Product Information' },
      ]
    : [
        { value: 'bom', label: 'Bill of Materials' },
        { value: 'measurement', label: 'Measurements' },
        { value: careLabel, label: 'Care Labels' },
        { value: 'product-information', label: 'Product Information' },
      ];

  const yearOptions = createOptions(getYears(), 'name', '_id');
  const monthOptions = createOptions(monthsPlaceholder, 'name', '_id');

  const [submitBtnState, setSubmitBtnState] = useState(true);
  const handleChangeSection = async (cgSection) => {
    reset();
    setSelectedType(null);
    setProductRef([]);
    setSelectedBomType(null);
    setBomComponentForm([]);
    setIsFormVisible(false);
    setSelectedTestinglibrary([]);
    setShowHideFormByProductInformation(false);
    setCurrentSection(cgSection?.value);
    setValue('section', cgSection, {
      shouldValidate: true,
    });

    setShowHideField((prev) => ({
      ...prev,
      showTestingLibraryDropDown: false,
    }));

    setSelectedSection(cgSection);
    if (cgSection?.value !== 'care-label') {
      setProductRef(null);
      setCareTabs([]);
      setValue('productRef', null);
    }
    setShowHideFormBySectionLabel((prev) => ({
      ...prev,
      testing: false,
      measurements: false,
      careLabels: false,
    }));

    setFormField((prev) => ({
      ...prev,
      proRefMultiSelect: true,
      proRefSelect: true,
      testinglibrary: true,
    }));

    if (cgSection) {
      setFormField((prev) => ({
        ...prev,
        type: false,
      }));
    }

    if (cgSection?.value !== 'bom') {
      setShowHideField((prevState) => ({
        ...prevState,
        type: false,
        bomComponent: false,
      }));
    }
    /* GET BOM TYPE FROM PRODUCT REF */
    if (cgSection !== null && cgSection.value === 'bom') {
      setShowHideField((prevState) => ({
        ...prevState,
        type: true,
        section: true,
        showTestingLibraryDropDown: false,
      }));
    } else {
      setShowHideField((prevState) => ({
        ...prevState,
        type: false,
      }));
      setBomTypeList(null);
    }
    /* GET BOM TYPE FROM PRODUCT REF END */

    setSelectedBomComponent([]);

    if (selectedType?.value === 'new' && cgSection?.value !== 'bom') {
      setShowHideField((prevState) => ({
        ...prevState,
        type: false,
        section: false,
      }));
    }
    if (selectedType?.value === 'amendment') {
      setShowHideField((prevState) => ({
        ...prevState,
        section: true,
      }));
    }

    if (!cgSection) {
      setFormField((prev) => ({
        ...prev,
        bomType: true,
        bomComponent: true,
      }));
    } else {
      setFormField((prev) => ({
        ...prev,
        bomType: false,
      }));
    }

    setShowHideFormBySectionLabel((prev) => ({
      ...prev,
      measurements: false,
    }));

    if (cgSection?.value === 'measurement') {
      setValue(
        'typeOptions',
        { value: 'amendment', label: 'Amendment' },
        {
          shouldValidate: true,
        },
      );
      setSelectedType({ value: 'amendment', label: 'Amendment' });
      setFormField((prev) => ({ ...prev, type: true, proRefSelect: false }));
    }
    if (cgSection?.value === 'product-information') {
      setValue(
        'typeOptions',
        { value: 'amendment', label: 'Amendment' },
        {
          shouldValidate: true,
        },
      );
      setSelectedType({ value: 'amendment', label: 'Amendment' });
      setFormField((prev) => ({ ...prev, type: true, proRefSelect: false }));
    }
    setFormField((prev) => ({
      ...prev,
      bomType: true,
    }));
  };
  useEffect(() => {
    if (careList?.tabs?.length > 0 && !careLabelEditMode && !suggId) {
      const filteredTabs = careList?.tabs
        .filter((tab) => !tab?.forDocument && sectionPermission?.isVisibleToSupplier?.[tab?.tabId])
        .map((tab) => {
          return {
            ...tab,
            tabDetails: tab?.tabDetails?.map((detail) => ({
              ...detail,
              isNew: false,
            })),
          };
        });

      setCareTabs(filteredTabs);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [careList, sectionPermission, suggId, careLabelEditMode]);

  const handleChangeType = (type_Options) => {
    reset();
    setIsFormVisible(false);
    setBomComponentForm([]);
    setSelectedBomType(null);
    setSelectedBomComponent([]);
    setSelectedTestinglibrary([]);

    setValue('typeOptions', type_Options, {
      shouldValidate: true,
    });
    setSelectedType(type_Options);
    if (selectedSection?.value === 'testing') {
      setProductRef(null);
      setFormField((prev) => ({ ...prev, bomType: true }));
    }

    if (selectedSection?.value === 'care-label') {
      setProductRef(null);
      setCareTabs([]);
      setValue('productRef', null);
    }

    if (selectedSection?.value === 'bom') {
      setProductRef([]);
      setFormField((prev) => ({ ...prev, bomType: true }));
    }

    setFormField((prev) => ({
      ...prev,
      proRefMultiSelect: false,
      proRefSelect: false,
    }));
    setShowHideField((prevState) => ({
      ...prevState,
      bomComponent: false,
    }));
    setUserState((prevState) => ({
      ...prevState,
      addNewRow: false,
    }));

    setShowHideField((prev) => ({
      ...prev,
      showTestingLibraryDropDown: selectedSection && selectedSection?.value === 'testing' && type_Options && type_Options.value === 'amendment',
    }));
  };

  const productRefOnChange = async (val) => {
    reset();
    setProductRefBlank([]);
    setValue('productRef', val);
    setProductRef([{ label: val.label, value: val.value }]);
    if (selectedSection?.value === 'care-label') {
      setCareTabs([]);
    }
    setBomComponentForm([]);
    setSelectedBomComponent([]);
    setSelectedTestinglibrary([]);
    setSelectedBomType(null);
    setFormField((prev) => ({
      ...prev,
      bomType: false,
      bomComponent: true,
    }));

    setFormField((prev) => ({
      ...prev,
      testinglibrary: false,
    }));

    const devIds = [];
    if (selectedSection?.value === 'testing' && selectedType.value !== 'new') {
      await dispatch(Action.getTestingLibraries(val.value, true));
      devIds.push(val.value);
      await dispatch(Action.getBomComponentRefCodes({ devOrderId: val.value }));
      await dispatch(Action.getColourWays({ loggedInUserId }));
    } else {
      devIds.push(val.value);
    }

    const document = {
      supplierId: loggedInUserId,
      devIds,
    };
    if (selectedSection && selectedSection?.value === 'bom') {
      await dispatch(fetchSupplier(val.value));
      await dispatch(Action.getBomTypeProductRef(document));
      await dispatch(supplierAction.fetchTierSSupplierListAction({ isWithFactory: false, tierType: 'Tier1' }));
    }

    if (selectedSection?.value === 'testing' && selectedType.value === 'new') {
      await dispatch(Action.getBomComponentRefCodes({ devOrderId: val.value }));
      await dispatch(Action.getColourWays({ loggedInUserId }));
      setTimeout(() => {
        testLibrariesAppend({
          code: '',
          description: '',
          type: null,
          minPassRate: '',
          bomComponent: null,
          colour: null,
          additionalInformation: '',
          status: 'Pending',
        });
      }, 100);
      setShowHideFormBySectionLabel((prev) => ({
        ...prev,
        testing: true,
      }));
      setIsFormVisible(true);
    }

    if (selectedSection?.value === 'measurement') {
      const optList = createOptions(val.gradingGroups, 'name', '_id');
      setGradingGroupsOptions(optList);
    }
    if (selectedSection?.value === 'product-information') {
      await dispatch(devOrderAction.getSuggestionProductDetail(val.value));
      devIds.push(val.value);
      disabledSubmitButton(val.length === 0);

      setShowHideFormByProductInformation((prev) => ({
        ...prev,
        productInformation: true,
      }));
      setIsFormVisible(true);
    }

    if (selectedSection?.value === careLabel) {
      setShowHideFormBySectionLabel((prev) => ({
        ...prev,
        careLabels: true,
      }));
      setIsFormVisible(true);
      setUserState((prevState) => ({
        ...prevState,
        tabCodes: [],
      }));

      const obj = {
        devOrderId: val?.value,
      };
      const careLabelPermission = await dispatch(Action.getCareLabelPermission(obj));
      setSectionPermission(careLabelPermission);
      await dispatch(careLabelAction.fetchCareInstructionProduct({ devOrderId: val?.value, isToFilter: true }));
    }
  };
  const setTestinglibraryMultiSelectOptions = (isDisabled) => {
    setTestinglibraryOptions([]);

    const testinglibraryOptionss =
      TestingLibraries?.map((item) => ({
        label: item.code,
        value: item._id,
        disabled: isDisabled,
      })) || [];

    setTestinglibraryOptions(testinglibraryOptionss);
  };

  const handleChangeTestingLibrary = async (libOptions) => {
    setTestinglibraryMultiSelectOptions(true);
    setIsFormVisible(true);
    setValue('testinglibrary', libOptions, {
      shouldValidate: true,
    });
    setSelectedTestinglibrary(libOptions);

    // for selected section is Testing
    if (selectedSection && selectedSection?.value === 'testing' && selectedType && selectedType.value === 'amendment' && libOptions.length > 0) {
      const results = TestingLibraries.filter((elem) => libOptions.find((el) => elem._id === el.value));
      if (libOptions && libOptions.length > 0) {
        testLibrariesRemove();
        if (results?.length > 0) {
          results.forEach((item) => {
            setTimeout(() => {
              testLibrariesAppend({ ...item });
            }, 100);
          });
        }
      } else {
        testLibrariesRemove();
      }

      setShowHideFormBySectionLabel((prev) => ({
        ...prev,
        testing: true,
      }));
    } else {
      testLibrariesRemove();
    }

    setTimeout(() => {
      setTestinglibraryMultiSelectOptions(false);
    }, 100);
  };

  const getCompositionAndUnitSupplier = async (bomTypeId) => {
    await dispatch(
      Action.getCompositionComponent({
        isActive: 1,
        loggedInUserId,
        bomTypeId,
      }),
    );
    await dispatch(
      Action.getSupplierSuggestUnits({
        isActive: true,
        loggedInUserId,
      }),
    );
    setIsCalledCompositionAndUnitSupplier(true);
  };
  const handleChangeBomType = async (bomType) => {
    if (!isCalledCompositionAndUnitSupplier) {
      getCompositionAndUnitSupplier(bomType?._id);
    }
    setBomComponentForm([]);
    setBomComponentData([]);
    setSelectedBomComponent([]);

    setValue('bomType', bomType, {
      shouldValidate: true,
    });
    setSelectedBomType(bomType);
    /* GET COMPONENT SUB TYPE */
    if (bomType !== null) {
      const data = await dispatch(
        Action.getComponentType({
          bomTypeId: bomType?._id,
        }),
      );
      setComponentType(data?.data);
    } else {
      setComponentType(null);
      reset();
    }
    /* GET COMPONENT SUB TYPE */
    if (selectedType && selectedType.value === 'amendment') {
      setShowHideField((prevState) => ({
        ...prevState,
        bomComponent: true,
      }));
      setFormField((prev) => ({ ...prev, bomComponent: false }));

      /* GET BOM TYPE FROM PRODUCT REF */
      if (bomType !== null) {
        const devIds = [];
        productRef?.map((item) => devIds.push(item.value));
        const document = {
          bomType: bomType?._id,
          devIds,
          isToFilterBoms: true,
        };
        dispatch(Action.getBomComponentProductRef(document));
      }
      /* GET BOM TYPE FROM PRODUCT REF END */
    }

    if (selectedType && selectedType.value === 'new' && selectedSection && selectedSection?.value === 'bom') {
      const defalutBomForm = {
        componentType: '',
        componentCode: '',
        component_des: '',
        supplier: '',
        size: '',
        sizeUnitOfMeasure: '',
        weight: '',
        weightUnitOfMeasure: '',
        quantity: '',
        quantityUnitOfMeasure: '',
        newPlacement: [],
        composition: defaultCompositionValue,
        additionalInfo: '',
        transport: null,
        quality: null,
        finished: null,
        bomComponentSubType: null,
        dynamicColumn: getDefaultDynamicColumns(bomType?._id) || [],
        subBomList: [],
        productImpact: null,
        pricePerUnit: '',
        pricePerUnitCurrency: '',
      };
      setIsFormVisible(true);
      setBomComponentForm([defalutBomForm]);
      setBomComponentData([]);
      append(defalutBomForm);
    }
  };

  const disabledSubmitButton = async (btnState) => {
    await setSubmitBtnState(btnState);
  };

  const getResults = (bomComp, data) => {
    if (!data.length) {
      return BOMComponent?.filter((elem) => bomComp.find((el) => elem._id === el.value));
    }
    return data;
  };

  const appendResults = async (results) => {
    remove();
    setIsFormVisible(true);
    await Promise.all(
      results?.map(async (item) => {
        await new Promise((resolve) => setTimeout(resolve, 100));
        const dynamicColumnData =
          item?.dynamicColumn && item.dynamicColumn.length > 0 ? item.dynamicColumn : getDefaultDynamicColumns(item?.bomTypeID || selectedBomType?._id);

        append({
          productName: item?.devOrderId?.number,
          componentType: item?.bomSubType,
          componentCode: item?.referenceCode,
          component_des: item?.bomDescription,
          supplier: item?.BOMSupplier?.[0] || item?.BOMSupplier || null,
          size: item?.size,
          sizeUnitOfMeasure: item?.sizeUnitOfMeasure,
          weight: item?.weight,
          weightUnitOfMeasure: item?.weightUnitOfMeasure,
          quantity: item?.quantity,
          quantityUnitOfMeasure: item?.quantityUnitOfMeasure,
          newPlacement: item?.newPlacement || [],
          status: item?.status,
          composition: item?.composition && item?.composition?.length > 0 ? item?.composition : defaultCompositionValue,
          additionalInfo: item?.additionalInfo,
          transport: item?.transport || null,
          quality: item?.quality || null,
          finished: item?.finished || null,
          bomComponentSubType: item?.bomComponentSubType || null,
          dynamicColumn: dynamicColumnData,
          subBomList: item?.subBomList || [],
          productImpact: item?.productImpact || null,
          pricePerUnit: item?.pricePerUnit || '',
          pricePerUnitCurrency: item?.pricePerUnitCurrency || '',
        });
      }),
    );
    setBomComponentForm(results);
  };

  const handleNoResults = () => {
    remove();
    setIsFormVisible(false);
    setBomComponentForm([]);
  };

  const handleChangeBomComponent = async (bomComp, data) => {
    setValue('bomComponent', bomComp);
    setSelectedBomComponent(bomComp);
    disabledSubmitButton(bomComp?.length === 0);

    const results = getResults(bomComp, data);
    if (results.length > 0) {
      await appendResults(results);
    } else {
      handleNoResults();
    }
  };

  const removeSelectedBomComponentInMultiSelect = async (item, i) => {
    const code = `${item.productName} - ${item.componentCode}`;
    await setSelectedBomComponent((prev) => prev.filter((_item) => _item.label !== code));
    await remove(i);
  };

  const removeSelectedTestingComponentInMultiSelect = async (item, i) => {
    await setSelectedTestinglibrary((prev) => prev.filter((el) => el.label !== item.code));
    await testLibrariesRemove(i);
  };

  const getProductRefData = async (id, sectionChange) => {
    setProductRefData([]);
    const data = await dispatch(
      Action.getSupplierProductRef({
        supplierId: id,
        role: userInfo.role,
        section: sectionChange,
        year: state.year?.value,
        month: state.month?.value,
        season: state.season?.value,
      }),
    );

    if (data) {
      const newProductRefData = data?.map((item) => ({
        label: item?.number,
        image: item?.image !== '' ? `${item?.image}` : noImage,
        value: item?._id,
        description: item?.description,
        sizeRanges: item?.sizeRanges,
        gradingGroups: item?.gradingGroups,
      }));
      setProductRefData(newProductRefData);
    }
  };

  function checkForDuplicateCodes(tabs) {
    const result = [];

    tabs.forEach((tab) => {
      // Find Code column ID
      const codeColumn = tab.tabColumns.find((col) => col.name === 'Code');
      if (!codeColumn) return;

      const codeColumnId = codeColumn._id;

      // Get all codes for this tab
      const codes = tab.tabDetails
        .filter((detail) => detail.columnId === codeColumnId)
        .map((detail) => detail.value)
        .filter(Boolean); // Remove null/undefined values
      // Check for duplicates
      const duplicates = codes.filter((code, index) => codes.indexOf(code) !== index);
      result.push(...duplicates);
    });

    return result?.length > 0;
  }

  const onSubmit = async (data) => {
    let isSubmitValid = true;
    let percentageExists = false;
    const isValids = selectedSection?.value !== 'care-label' || (selectedSection?.value === 'care-label' && submitValidate());

    // Add validation for factory modification when section is product-information
    if (selectedSection?.value === 'product-information') {
      const originalFactories = editedDevOrderData?.supplierFactories || [];
      const modifiedFactories = editedSupplierFactory?.selectedSupplierFactories || [];

      if (isEqual(originalFactories.sort(), modifiedFactories.sort())) {
        toasterMsg(t('SUPPLIER_SUGGESTION_DETAIL.NO_FACTORY_CHANGES'), t('DANGER'));
        return;
      }
    }

    if (data.bomForm) {
      data.bomForm.forEach((bomItem) => {
        const composition = bomItem.composition || [];
        let totalPercentage = 0;

        composition.forEach((comp) => {
          const percentage = parseFloat(comp.percentage);
          if (!isNaN(percentage) && percentage > 0) {
            // Check if there is a valid non-zero percentage
            percentageExists = true;
            totalPercentage += percentage;
          }
        });

        if (percentageExists && Math.abs(totalPercentage - 100) > 0.001) {
          isSubmitValid = false;
        }
      });
    }

    if (!isSubmitValid) {
      toasterMsg(t('BOM_TYPE_GROUP_VIEW.VALIDATION_ERROR.TOTAL_PERCENTAGE_VALIDATION'), t('DANGER'));
      return;
    }
    if (suggId) {
      const productRefDataForRed = productRefFromReducer.filter((el) => el._id === data?.productRef[0]?.value);
      data.productRef = productRefDataForRed[0];
    }
    let bomArray = [];
    if (bomComponentForm?.length) {
      const filteredBomComponent = await bomComponentForm.filter(({ referenceCode }) =>
        data.bomForm.find(({ componentCode }) => referenceCode === componentCode),
      );

      bomArray =
        data?.bomForm?.length > 0 &&
        (await data?.bomForm?.map((ele, i) => {
          return {
            devOrderId: filteredBomComponent[i]?.devOrderId?._id,
            libId: filteredBomComponent[i]?.libId,
            bomLibId: filteredBomComponent[i]?._id,
            bomSubType: ele?.componentType?._id,
            referenceCode: ele?.componentCode,
            bomDescription: ele?.component_des,
            BOMSupplier: ele?.supplier?._id,
            size: ele?.size,
            sizeUnitOfMeasure: ele?.sizeUnitOfMeasure?._id,
            weight: ele?.weight,
            weightUnitOfMeasure: ele?.weightUnitOfMeasure?._id,
            quantity: ele?.quantity,
            quantityUnitOfMeasure: ele?.quantityUnitOfMeasure?._id,
            newPlacement: ele?.newPlacement?.map((item) => item?.value || item?._id) || [],
            bomComponentSubType: ele?.bomComponentSubType?._id || null,
            finished: ele?.finished?._id || null,
            transport: ele?.transport || null,
            quality: ele?.quality || null,
            composition: ele?.composition,
            additionalInfo: ele?.additionalInfo,
            status: ele?.status || 'Pending',
            comment: ele?.comment,
            createdBy: ele?.createdBy,
            dynamicColumn: ele?.dynamicColumn || [],
            subBomList: ele?.subBomList || [],
            productImpact: ele?.productImpact || null,
            pricePerUnit: ele?.pricePerUnit || '',
            pricePerUnitCurrency: ele?.pricePerUnitCurrency?.value || ele?.pricePerUnitCurrency || '',
          };
        }));

      if (data?.typeOptions?.value === 'amendment') {
        bomArray =
          (await bomArray) &&
          bomArray.map((item) => {
            return { ...item, _id: item?.bomLibId };
          });
      }
      data.bomForm = bomArray;
    }
    const testingCodeBomColor = [];

    data.testLibraries =
      data?.testLibraries?.map((item) => {
        const testingCode = `${item?.code}__${item?.bomComponent?._id}__${item?.colour?._id}`;
        testingCodeBomColor.push(testingCode);
        return {
          ...item,
          type: item?.type.label || item?.type,
          bomComponent: item?.bomComponent?._id,
          colour: item?.colour?._id,
          status: item?.status || 'Pending',
          libId: item?.libId === '' ? null : item?.libId,
        };
      }) || [];

    const devIds = [];
    if (productRef?.length > 0) {
      productRef?.map((item) => devIds.push(item.value));
    } else if (productRef) {
      devIds.push(productRef.value);
    }
    if (!isEmpty(data.bomForm)) {
      data.bomForm = await data?.bomForm?.map((item) => {
        return {
          ...item,
          composition: item?.composition?.filter((compo) => {
            return compo.percentage !== null || compo.composition !== null;
          }),
        };
      });

      data.bomForm = await Promise.all(data?.bomForm);
    }
    if (data?.pomLibraries?.length) {
      data.pomLibraries = await data.pomLibraries.map((item) => {
        return {
          ...item,
          status: item?.status || 'Pending',
        };
      });
    }

    if (data?.specPomLibraries?.length) {
      data.specPomLibraries = await data.specPomLibraries.map((_item) => {
        return {
          ..._item,
          status: _item?.status || 'Pending',
        };
      });
    }
    let sizeRanges = [];
    if (selectedSection?.value === 'measurement') {
      if (checkArray(origanalMeasurmentData?.[0]?.sizeRanges) && checkArray(data?.productRef?.sizeRanges)) {
        sizeRanges = origanalMeasurmentData?.[0]?.sizeRanges?.filter((element) => data?.productRef?.sizeRanges?.includes(element));
      } else if (checkArray(origanalMeasurmentData?.[0]?.sizeRanges)) {
        sizeRanges = origanalMeasurmentData?.[0]?.sizeRanges;
      } else if (checkArray(data?.productRef?.sizeRanges)) {
        sizeRanges = data?.productRef?.sizeRanges;
      }
    }

    const submitObj = {
      supplierId: loggedInUserId,
      devOrderIds: devIds,
      type: selectedType?.value,
      section: selectedSection?.value,
      comment: data?.comment,
      bomType: selectedBomType?._id,
      bomComponents: selectedSection?.value === 'bom' ? data?.bomForm : [],
      testLibraries: selectedSection?.value === 'testing' ? data?.testLibraries : [],
      productInformationLibraries:
        selectedSection?.value === 'product-information'
          ? [
              {
                number: editedDevOrderData?.number,
                devOrderId: editedDevOrderData?._id,
                suppliers: editedDevOrderData?.suppliers || [],
                supplierFactories: editedSupplierFactory?.selectedSupplierFactories || [],
              },
            ]
          : [],
      measurementLibaries:
        selectedSection?.value === 'measurement'
          ? {
              sizeRanges: sizeRanges || [],
              pomLibraries: data?.pomLibraries,
              specPomLibraries: data.specPomLibraries,
            }
          : [],
      careLableLibaries:
        selectedSection?.value === careLabel
          ? {
              devOrderId: devIds,
              tabs: careTabs.map((tab) => ({
                ...tab,
                tabDetails: tab.tabDetails
                  .filter((detail) => {
                    if (selectedType?.value === 'new' && !suggId) {
                      return detail?.isNew === true;
                    }
                    if (selectedType?.value === 'amendment' && !suggId) {
                      return ids?.[tab?.tabId]?.includes(detail?.rowId);
                    }
                    return detail;
                  })
                  .map((detail) => ({
                    ...detail,
                    status: detail?.status || 'Pending',
                  })),
              })),
            }
          : [],
      year: state?.year?.value,
      month: state?.month?.value,
      season: state?.season?.value,
    };
    if (selectedSection?.value === 'measurement') {
      submitObj.gradingGroupId = selectedGrading.value;
    }

    let isDuplicates = false;
    if (selectedSection?.value === 'testing') {
      isDuplicates = hasDuplicates(testingCodeBomColor);
    } else if (selectedSection?.value === careLabel) {
      isDuplicates = checkForDuplicateCodes(careTabs);
    }
    if (!isDuplicates) {
      let response = null;
      if (isValids) {
        setLoader(true);
        if (suggId) {
          submitObj.suggestionId = suggId;
          response = await dispatch(Action.updateSuggestion(submitObj, t));
        } else response = await dispatch(Action.AddSuggestion(submitObj, t));
      }
      if (response) {
        const detailURL = `/supplier-suggestion/detail/${response?._id}/${selectedSection?.value}`;
        setClearImage(!clearImage);
        history.push({
          pathname: detailURL,
        });
      }
      setLoader(false);
    } else {
      if (selectedSection && selectedSection?.value === 'testing') {
        toasterMsg(t('SUPPLIER_SUGGESTION_FORM.TESTING_COMBINATION'), t('SUPPLIER_SUGGESTION_FORM.DANGER'));
      } else if (selectedSection && selectedSection?.value === careLabel) {
        toasterMsg(t('SUPPLIER_SUGGESTION_FORM.CODE_SHOULD_UNIQUE'), t('SUPPLIER_SUGGESTION_FORM.DANGER'));
      }
      setLoader(false);
    }
  };

  const getGradingData = async () => {
    const obj = {
      gradings: !showGrading,
      loggedInUserId,
      gradingGroupId: selectedGrading.value,
    };
    const response = await dispatch(Action.getHideShowGrading(productRef[0]?.value, obj));
    if (response) setShowGrading(!showGrading);
  };

  const getOldBomComponent = async (typeId, id) => {
    const document = {
      bomType: typeId,
      devIds: id,
      isToFilterBoms: false,
    };
    let bomCmpDataArr = [];
    bomCmpDataArr = await dispatch(Action.getBomComponentProductRef(document));
    return bomCmpDataArr;
  };

  const onEditBom = async (type, bomComp, bomComponents, product_ref, suggestionType) => {
    setSelectedBomType(type);
    setValue('bomType', type, {
      shouldValidate: true,
    });

    const dataArr = await getOldBomComponent(type._id, [product_ref[0].value]);

    const newBomDataArry = bomComponents.map((item) => {
      const oldData = Array.isArray(dataArr) && dataArr.filter((e) => e._id === item._id);
      if (oldData?.length === 0 && suggestionType !== 'new' && item.status !== 'Approved') {
        return {
          ...item,
          status: 'Deleted',
        };
      }
      return {
        ...item,
      };
    });
    handleChangeBomComponent(bomComp, newBomDataArry);
  };

  const onEditTesting = async (testingData, id, suggestionType) => {
    await dispatch(Action.getBomComponentRefCodes({ devOrderId: id }));
    await dispatch(Action.getColourWays({ loggedInUserId }));

    const oldDataRes = await dispatch(Action.getTestingLibraries(id, true));

    const newTestLibrary = testingData.map((item) => {
      const oldData = Array.isArray(oldDataRes) && oldDataRes.filter((e) => e._id === item._id);

      if (oldData?.length === 0 && suggestionType !== 'new' && item.status !== 'Approved') {
        return {
          ...item,
          status: 'Deleted',
        };
      }
      return {
        ...item,
      };
    });

    const testingLib = newTestLibrary.map((item) => {
      return {
        label: item.bomComponent?.referenceCode ? item.bomComponent?.referenceCode : null,
        value: item.bomComponent?._id,
        disabled: false,
      };
    });
    setIsFormVisible(true);
    setValue('testinglibrary', testingLib, {
      shouldValidate: true,
    });
    setSelectedTestinglibrary(testingLib);

    newTestLibrary.forEach(async (item) => {
      await testLibrariesAppend({ ...item });
    });
    setShowHideFormBySectionLabel((prev) => ({
      ...prev,
      testing: true,
    }));
  };

  const getOldMeasurementDetail = async (devOrderId, gradingGroupId) => {
    let oldData = [];
    const param = {
      devOrderId,
      gradingGroupId,
      isToFilterMeasurement: true,
      allData: true,
    };
    oldData = await dispatch(Action.getSelectedGradGroupDataSupplier(param));
    return oldData;
  };

  const onEditMeasurement = async (sec, id, measurement_data) => {
    setMeasurementEditMode(true);
    setShowHideFormBySectionLabel((prev) => ({
      ...prev,
      measurements: true,
    }));

    const oldDataArr = await getOldMeasurementDetail(id, measurement_data.gradingGroupId);

    const measurementPermission = await dispatch(Action.getMeasurementPermission({ devOrderId: id }));
    setSectionPermission(measurementPermission);

    const measurmentData = measurement_data?.measurementLibaries;

    setProductRefData([]);
    await dispatch(
      Action.getSupplierProductRef({
        supplierId: loggedInUserId,
        role: userInfo.role,
        section: sec,
      }),
    );

    await dispatch(Action.measurementSuggestionAction(measurmentData));
    setOriganalMeasurmentData(measurmentData);

    const { conversionType, fraction, hideGradings } = oldDataArr[0];

    setConversationData({
      conversionType,
      fraction,
    });

    setHideGradings(hideGradings);
    setOldMeasurmentData(oldDataArr);

    const newPomDataArr = measurmentData[0].pomLibraries;
    const newSpecDataArr = measurmentData[0].specPomLibraries;

    await specPomLibrarieRemove();

    const pomLib = newPomDataArr;
    const specPomLib = newSpecDataArr;

    disabledSubmitButton(pomLib.length === 0 && specPomLib.length === 0);

    setHideGradings(hideGradings);

    setShowHideFormBySectionLabel((prev) => ({
      ...prev,
      measurements: true,
    }));
    setIsFormVisible(true);
    if (pomLib) setEditedPomLibraries(pomLib);
    if (specPomLib) setEditedSpecPomLibraries(specPomLib);
  };

  const onEditCareLabel = async (id, careLable_data, suggestionType) => {
    const careLabelPermission = await dispatch(Action.getCareLabelPermission({ devOrderId: id }));

    const careLableLibaries = careLable_data[0];
    const oldDataArr = await dispatch(careLabelAction.fetchCareInstructionProduct({ devOrderId: id, isToFilter: true }));

    const tabs = careLableLibaries.tabs.map((tab) => {
      if (suggestionType !== 'new' && tab?.tabDetails) {
        // Find matching tab in oldDataArr
        const matchingTab = oldDataArr?.tabs?.find((oldTab) => oldTab?.tabId === tab?.tabId);

        // If no matching tab found or tab details don't exist in oldDataArr, mark for deletion
        if (matchingTab?.tabDetails?.length === 0) {
          return {
            ...tab,
            status: 'Deleted',
          };
        }

        // Check if all tabDetails in current tab exist in matching oldDataArr tab
        const hasMatchingDetails = tab.tabDetails.every((detail) => {
          return matchingTab.tabDetails.some((oldDetail) => oldDetail?.rowId === detail?.rowId);
        });

        if (!hasMatchingDetails) {
          return {
            ...tab,
            status: 'Deleted',
          };
        }
      }
      return tab;
    });
    setCareTabs(tabs);
    setShowHideFormBySectionLabel((prev) => ({
      ...prev,
      careLabels: true,
    }));
    setIsFormVisible(true);
    setCareLabelEditMode(true);
    setSectionPermission(careLabelPermission);
  };

  useEffect(() => {
    return () => {
      setCareTabs([]);
      setUserState((prev) => ({
        ...prev,
        editingRowId: '',
        showImageUpload: false,
        addNewRow: false,
        selectedImageRowIndex: '',
        selectedImageRowColumnId: '',
        rowImage: null,
        showImgDeleteModal: false,
        tabCodes: null,
      }));
    };
  }, []);

  // all useEffect collection
  useEffect(() => {
    setSectionList(sectionOptionsArray);
  }, [section]);

  useEffect(() => {
    BOMComponent.forEach((item) => {
      setBomComponentData((prev) => [
        ...prev,
        {
          label: `${item.devOrderId.number} - ${item.referenceCode}`,
          value: item._id,
        },
      ]);
    });
  }, [BOMComponent]);

  useEffect(() => {
    setBomTypeList(BomType);
  }, [BomType]);

  useEffect(() => {
    setTestinglibraryMultiSelectOptions(false);
  }, [TestingLibraries]);

  useEffect(() => {
    if (MeasurementSuggestion?.length > 0) setMeasurementSuggestion([...MeasurementSuggestion]);
  }, [MeasurementSuggestion]);

  const onEditProduct = async (product_ref, suggestionType) => {
    if (product_ref && product_ref.length > 0) {
      setProductRef(
        product_ref.map((ref) => ({
          label: ref.label,
          value: ref.value,
        })),
      );
      setShowHideFormByProductInformation((prev) => ({
        ...prev,
        productInformation: true,
      }));
      setValue('productRef', product_ref[0].value, {
        shouldValidate: true,
      });

      await dispatch(devOrderAction.getSuggestionProductDetail(product_ref[0].value));
    }
  };

  useEffect(() => {
    const callFn = async () => {
      const sugestionObj = {
        suggestionId: suggId,
        section: activeSection,
      };
      const data = await dispatch(Action.fetchSuggestionDetail(sugestionObj));
      if (data) {
        setSuggestionEditMode(true);

        const { _id, number } = data.devOrderIds[0];
        const bomCmp = data.bomComponents.map((item) => {
          return {
            label: `${item?.devOrderId?.number} - ${item?.referenceCode}`,
            value: item._id,
          };
        });

        const obj = {
          section: sectionOptionsArray.filter((opt) => opt.value === data.section)[0],
          type: typeOptions.filter((otp) => otp.value === data.type)[0],
          productRef: [{ label: number, value: _id }],
          bomType: data.bomType,
          bomComp: bomCmp,
        };

        setShowHideField({
          section: true,
          type: data.section === 'bom',
          bomComponent: data.section === 'bom',
          showTestingLibraryDropDown: data.section === 'testing',
        });
        setSelectedSection(obj.section);
        setState((prev) => ({
          ...prev,
          month: monthOptions?.find((mon) => mon.value === data?.month),
          year: yearOptions?.find((year) => year.label === data?.year),
          season: seasonOptions?.find((sea) => sea.value === data?.season),
          seasonValue: data?.season,
        }));
        setValue('section', obj.section, {
          shouldValidate: true,
        });

        setSelectedType(obj.type);
        setValue('typeOptions', obj.type, {
          shouldValidate: true,
        });

        setProductRef(obj.productRef);
        setValue('productRef', obj.productRef);
        setValue('comment', data.comment);

        if (obj.section.value === 'bom') onEditBom(obj.bomType, obj.bomComp, data.bomComponents, obj.productRef, obj.type.value);
        if (obj.section.value === 'product-information') {
          onEditProduct(obj.productRef, obj.type.value);
        }
        if (obj.section.value === 'testing') {
          onEditTesting(data.testLibraries, _id, obj.type.value);
        }

        if (obj.section.value === 'measurement' && data.measurementLibaries) {
          onEditMeasurement(obj.section.value, _id, data);
          const obj1 = {
            label: data?.gradingGroup?.name,
            value: data?.gradingGroup?._id,
          };
          setSelectedGrading(obj1);
        }

        if (obj.section.value === careLabel) onEditCareLabel(_id, data.careLableLibaries, obj.type.value);
      }
    };
    if (!isEmpty(suggId) && !isEmpty(section)) {
      callFn();
    }
  }, [suggId, activeSection]);

  const isDisabledWhileInEdit = !isEmpty(suggId) && !isEmpty(section);

  const onChange = (val, name) => {
    setValue('productRef', null);
    setProductRef(null);
    setProductRefBlank([]);
    setShowHideFormByProductInformation({});
    setSectionPermission(null);
    setSelectedGrading(null);

    setState((prev) => ({
      ...prev,
      [name]: val,
    }));
  };

  useEffect(() => {
    if (selectedSection && selectedType) {
      getProductRefData(loggedInUserId, selectedSection?.value);
    }
  }, [selectedSection, selectedType, state]);

  const getMeasurementData = async (val) => {
    setShowHideFormBySectionLabel((prev) => ({
      ...prev,
      measurements: true,
    }));
    const obj = {
      devOrderId: productRef[0]?.value,
    };
    const measurementPermission = await dispatch(Action.getMeasurementPermission(obj));
    setSectionPermission(measurementPermission);

    await dispatch(Action.getMeasurementSuggestion(productRef[0]?.value));
    const param = {
      devOrderId: productRef[0]?.value,
      gradingGroupId: val.value,
      isToFilterMeasurement: true,
      allData: true,
    };
    const measurementData1 = await dispatch(Action.getSelectedGradGroupDataSupplier(param));
    console.log('🚀 ~ file: SupplierSuggestion.js:1463 ~ getMeasurementData ~ measurementData1:', measurementData1);
    setOriganalMeasurmentData(measurementData1);
    if (measurementData1?.length > 0 && measurementData1[0] !== null) {
      setOriganalMeasurmentData(measurementData1);
      const { conversionType, fraction, hideGradings } = measurementData1[0];
      setConversationData({
        conversionType,
        fraction,
      });

      setHideGradings(hideGradings);

      pomLibrariesRemove();
      specPomLibrarieRemove();

      setShowHideFormBySectionLabel((prev) => ({
        ...prev,
        measurements: true,
      }));
      setIsFormVisible(true);
    }
  };
  return (
    <FormProvider
      {...{
        control,
        register,
        fields,
        isValid,
        trigger,
        watch,
        productRef,
        disabledSubmitButton,

        append,
        remove,

        testLibrariesArray,
        testLibrariesAppend,
        testLibrariesRemove,

        pomLibrariesFields,
        pomLibrariesAppend,
        pomLibrariesRemove,
        pomUpdateLibraries,
        pomLibrariesInsert,

        specPomLibrariesFields,
        specPomLibrariesAppend,
        specPomLibrarieRemove,
        specPomLibrarieInsert,
        specPomUpdateLibraries,

        origanalMeasurmentData,
        conversationData,

        careSymbolFields,
        careSymbolAppend,
        careSymbolRemove,

        careInstructionFields,
        careInstructionAppend,
        careInstructionRemove,

        careDisclaimerFields,
        careDisclaimerAppend,
        careDisclaimerRemove,

        getValues,
        errors,
        setValue,
        reset,
        pomLibrariesreplace,
        clearErrors,
        measurementEditMode,
        careLabelEditMode,
        suggestionEditMode,

        editedPomLibraries,
        editedSpecPomLibraries,
        oldMeasurmentData,
      }}
    >
      {loader ? (
        <Loader />
      ) : (
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="page-title-filter sticky">
            <div className="title-container">
              <h4 className="title">
                {suggestionEditMode && t('SUPPLIER_SUGGESTION_FORM.EDIT_SUGGESTION')}
                {!suggestionEditMode && t('SUPPLIER_SUGGESTION_FORM.ADD_SUGGESTION')}
              </h4>
            </div>

            <div className="search-filter">
              {selectedSection?.value === 'measurement' && (
                <button disabled={!specPomLibrariesFields.length} className="btn btn-white btn-back-lib" type="button" onClick={() => getGradingData()}>
                  {showGrading ? t('SUPPLIER_SUGGESTION_FORM.HIDE_GRADING') : t('SUPPLIER_SUGGESTION_FORM.SHOW_GRADING')}
                </button>
              )}
              <div className="floting-actions">
                <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.SAVE')}>
                  <button aria-label="Save" type="submit" disabled={suggestionEditMode ? false : submitBtnState} className="btn p-0">
                    <i className="icon-Save-1 f-24" />
                  </button>
                </CustomTooltip>
              </div>

              <CustomTooltip placement="bottom" tooltipText={t('COMMON_LABEL.CLOSE')}>
                <Link className="cursor-pointer text-dark text-decoration-none btn" to={history.location.state?.returnUrl || '/supplier-suggestion'}>
                  <i className="icon-close f-20" />
                </Link>
              </CustomTooltip>
            </div>
          </div>
          <div className="pb-100">
            <div className="container-fluid mt-16 mb-16">
              <Row>
                <Col lg="2">
                  <FormGroup>
                    <div className={`common-react-select flex-fill  ${formField.section ? 'disabled' : ''} `}>
                      <label htmlFor="section" className="field-lbl mb-0 f-16 font-heavy asterisk-req">
                        {t('SUPPLIER_SUGGESTION_FORM.SECTION')}
                        <span>*</span>
                      </label>
                      <Select
                        name="section"
                        {...register('section', {
                          required: true,
                        })}
                        options={sectionList}
                        getOptionLabel={(option) => `${option.label}`}
                        getOptionValue={(option) => `${option.value}`}
                        value={selectedSection}
                        onChange={(val) => {
                          handleChangeSection(val);
                        }}
                        // styles={SelectBoxStyles}
                        className="common-select"
                        classNamePrefix="common-select"
                        placeholder={t('SUPPLIER_SUGGESTION_FORM.SELECT_SECTION')}
                        isDisabled={isDisabledWhileInEdit}
                      />
                    </div>

                    {errors?.section && <small className="error-message">{t('SUPPLIER_SUGGESTION_FORM.SECTION_REQUIRED')}</small>}
                  </FormGroup>
                </Col>

                <Col lg="2">
                  <FormGroup className="">
                    <div className={`common-react-select flex-fill  ${formField.type ? 'disabled' : ''} `}>
                      <label htmlFor="typeOptions" className="field-lbl mb-0 f-16 font-heavy asterisk-req">
                        {t('SUPPLIER_SUGGESTION_FORM.TYPE')}
                        <span>*</span>
                      </label>
                      <Select
                        name="typeOptions"
                        {...register('typeOptions', {
                          required: true,
                        })}
                        options={typeOptions}
                        // styles={SelectBoxStyles}
                        placeholder={t('SUPPLIER_SUGGESTION_FORM.SELECT_TYPE')}
                        getOptionLabel={(option) => `${option.label}`}
                        getOptionValue={(option) => `${option.value}`}
                        value={selectedType}
                        onChange={handleChangeType}
                        isDisabled={isDisabledWhileInEdit}
                        className="common-select"
                        classNamePrefix="common-select"
                      />
                    </div>

                    {errors?.typeOptions && <small className="error-message">{t('SUPPLIER_SUGGESTION_FORM.TYPE_REQUIRED')}</small>}
                  </FormGroup>
                </Col>
                <Col lg="2">
                  <FormGroup>
                    <div className="common-react-select flex-fill">
                      <label htmlFor="season" className="field-lbl mb-0 f-16 font-heavy asterisk-req">
                        {t('SUPPLIER_SUGGESTION_FORM.SEASON')}
                      </label>
                      <Select
                        name="season"
                        options={seasonOptions}
                        getOptionValue={(option) => option.value}
                        value={state?.season || seasonOptions?.find((sea) => sea.value === state?.seasonValue)}
                        onChange={(val) => {
                          onChange(val, 'season');
                        }}
                        isClearable
                        // styles={SelectBoxStyles}
                        placeholder={t('SUPPLIER_SUGGESTION_FORM.SELECT_SEASON')}
                        isDisabled={isDisabledWhileInEdit}
                        className="common-select"
                        classNamePrefix="common-select"
                      />
                    </div>
                  </FormGroup>
                </Col>
                <Col lg="2">
                  <FormGroup>
                    <div className="common-react-select flex-fill">
                      <label htmlFor="month" className="field-lbl mb-0 f-16 font-heavy asterisk-req">
                        {t('SUPPLIER_SUGGESTION_FORM.MONTH')}
                      </label>
                      <Select
                        name="month"
                        options={monthOptions}
                        getOptionValue={(option) => option.value}
                        value={state?.month}
                        onChange={(val) => {
                          onChange(val, 'month');
                        }}
                        isClearable
                        // styles={SelectBoxStyles}
                        isDisabled={isDisabledWhileInEdit}
                        placeholder={t('SUPPLIER_SUGGESTION_FORM.SELECT_MONTH')}
                        className="common-select"
                        classNamePrefix="common-select"
                      />
                    </div>
                  </FormGroup>
                </Col>

                <Col lg="2">
                  <FormGroup>
                    <div className="common-react-select flex-fill">
                      <label htmlFor="year" className="field-lbl mb-0 f-16 font-heavy asterisk-req">
                        {t('SUPPLIER_SUGGESTION_FORM.YEAR')}
                      </label>
                      <Select
                        components={{ Option: CurrentYearOption }}
                        name="year"
                        options={yearOptions}
                        getOptionValue={(option) => option.value}
                        value={state?.year}
                        onChange={(val) => {
                          onChange(val, 'year');
                        }}
                        isClearable
                        isDisabled={isDisabledWhileInEdit}
                        // styles={SelectBoxStyles}
                        className="common-select"
                        classNamePrefix="common-select"
                        placeholder={t('SUPPLIER_SUGGESTION_FORM.SELECT_YEAR')}
                      />
                    </div>
                  </FormGroup>
                </Col>
                <Col lg="2">
                  <FormGroup className="suggestion-product-ref">
                    <div className="common-react-select flex-fill">
                      <label htmlFor="productRef" className="field-lbl mb-0 f-16 font-heavy asterisk-req">
                        {t('SUPPLIER_SUGGESTION_FORM.PRODUCT_REF')}
                        <span>*</span>
                      </label>
                      <Select
                        name="productRef"
                        {...register('productRef', {
                          required: true,
                        })}
                        isDisabled={formField.proRefSelect || isDisabledWhileInEdit}
                        options={productRefData}
                        formatOptionLabel={(option) => (
                          <div className="d-flex align-items-center">
                            {option.image && <img width="30" src={option.image} alt="" />}
                            <div className="d-flex flex-column mx-2">
                              <span>{option.label}</span>
                              <div>{shortenStringWithTooltip(option.description, 25)}</div>
                            </div>
                          </div>
                        )}
                        getOptionValue={(option) => option.value}
                        value={productRef}
                        onChange={async (val) => {
                          productRefOnChange(val);
                        }}
                        classNamePrefix="common-select"
                        className="common-select"
                        // styles={SelectBoxStyles}
                        placeholder={t('SUPPLIER_SUGGESTION_FORM.SELECT_PRODUCT_REF')}
                      />
                    </div>
                    {errors.productRef && <small className="error-message">{t('SUPPLIER_SUGGESTION_FORM.PRODUCT_REF_REQUIRED')}</small>}
                  </FormGroup>
                </Col>

                {selectedSection?.value === 'measurement' && (
                  <Col lg="3">
                    <FormGroup>
                      <div className="common-react-select flex-fill">
                        <label htmlFor="Grading Group" className="field-lbl mb-0 f-16 font-heavy asterisk-req">
                          {t('SUPPLIER_SUGGESTION_FORM.GRADING_GROUP')}
                          <span>*</span>
                        </label>
                        <Select
                          name="Grading Group"
                          isDisabled={formField.proRefSelect || isDisabledWhileInEdit}
                          options={gradingGroupsOptions}
                          getOptionValue={(option) => option.value}
                          value={selectedGrading}
                          onChange={async (val) => {
                            setSelectedGrading(val);
                            getMeasurementData(val);
                          }}
                          classNamePrefix="common-select"
                          className="common-select"
                          // styles={SelectBoxStyles}
                          placeholder={t('SUPPLIER_SUGGESTION_FORM.SELECT_GRADING_GROUP')}
                        />
                      </div>
                      {errors.productRef && <small className="error-message">{t('SUPPLIER_SUGGESTION_FORM.GRADING_GROUP_REQUIRED')}</small>}
                    </FormGroup>
                  </Col>
                )}
                {showHideField.showTestingLibraryDropDown && (
                  <Col lg="3">
                    <FormGroup>
                      <div className="custom-react-select flex-fill">
                        <label htmlFor="testinglibrary" className="field-lbl mb-0 f-16 font-heavy asterisk-req">
                          {t('SUPPLIER_SUGGESTION_FORM.TESTING_LIBRARY')}
                          <span>*</span>
                        </label>
                        <MultiSelect
                          name="testinglibrary"
                          {...register('testinglibrary', {
                            required: true,
                          })}
                          className="product-custom-multiselect common-new-multiselect"
                          disabled={formField.testinglibrary || isDisabledWhileInEdit}
                          options={testinglibraryOptions || []}
                          value={selectedTestinglibrary}
                          onChange={handleChangeTestingLibrary}
                        />
                      </div>

                      {errors.testinglibrary && <small className="error-message">{t('SUPPLIER_SUGGESTION_FORM.TESTING_LIBRARY_REQUIRED')}</small>}
                    </FormGroup>
                  </Col>
                )}

                {showHideField.type && showHideField.section && (
                  <Col lg="2">
                    <FormGroup>
                      <div className={`common-react-select flex-fill  ${formField.bomType ? 'disabled' : ''} `}>
                        <label htmlFor="bomType" className="field-lbl mb-0 f-16 font-heavy asterisk-req">
                          {t('SUPPLIER_SUGGESTION_FORM.BOM_TYPE')}
                          <span>*</span>
                        </label>
                        <Select
                          name="bomType"
                          {...register('bomType', {
                            required: true,
                          })}
                          options={bomTypeList}
                          getOptionLabel={(option) => `${option.name}`}
                          getOptionValue={(option) => `${option._id}`}
                          onChange={(val) => {
                            handleChangeBomType(val);
                          }}
                          value={selectedBomType}
                          className="common-select"
                          classNamePrefix="common-select"
                          // styles={SelectBoxStyles}
                          placeholder={t('SUPPLIER_SUGGESTION_FORM.SELECT_BOM_TYPE')}
                          isDisabled={isDisabledWhileInEdit}
                        />
                      </div>
                      {errors.bomType && <small className="error-message">{t('SUPPLIER_SUGGESTION_FORM.BOM_TYPE_REQUIRED')}</small>}
                    </FormGroup>
                  </Col>
                )}

                {showHideField.bomComponent && (
                  <Col lg="2">
                    <FormGroup>
                      <div className={` flex-fill  ${formField.bomComponent ? 'disabled' : ''} `}>
                        <label htmlFor="bomComponent" className="field-lbl mb-0 f-16 font-heavy  asterisk-req">
                          {t('SUPPLIER_SUGGESTION_FORM.BOM_COMPONENT')}
                          <span>*</span>
                        </label>

                        <MultiSelect
                          name="bomComponent"
                          {...register('bomComponent', {
                            required: true,
                          })}
                          options={bomComponentData}
                          className="product-custom-multiselect common-new-multiselect"
                          value={selectedBomComponent}
                          onChange={(val) => {
                            handleChangeBomComponent(val, []);
                          }}
                          labelledBy={t('SUPPLIER_SUGGESTION_FORM.SELECT_SUPLIER')}
                        />
                      </div>
                      {errors?.bomComponent && <small className="error-message">{t('SUPPLIER_SUGGESTION_FORM.BOM_COMPONENT_REQUIRED')}</small>}
                    </FormGroup>
                  </Col>
                )}
              </Row>
            </div>
            {showHideFormByProductInformation?.productInformation && (
              <ProductTypeForm
                editedSupplierFactory={editedSupplierFactory}
                setEditedSupplierFactory={setEditedSupplierFactory}
                typeOptions={typeOptions?.find((e) => e.value === 'amendment')}
                // supplierFactoriesOptions={supplierFactoriesOptions}
              />
            )}

            {isFormVisible && bomComponentForm && bomComponentForm.length > 0 && (
              <div className="container-fluid">
                <Row>
                  <Col lg={12}>
                    <BomTypeForm
                      selectedBomType={selectedBomType}
                      componentType={componentType}
                      currentSection={currentSection}
                      selectedType={selectedType}
                      removeSelectedBomComponent={removeSelectedBomComponentInMultiSelect}
                      customAttributeBomList={customAttributeBomList}
                      devOrderId={BOMComponent[0]?.bomType}
                      clonedBomData={clonedBomData}
                      setState={setState}
                      supplierOptions={supplierOptions}
                      defaultDynamicColumns={getDefaultDynamicColumns(selectedBomType?._id)}
                    />
                  </Col>
                </Row>
              </div>
            )}

            {showHideFormBySectionLabel.testing && (
              <TestingSuggestion selectedType={selectedType} removeSelectedTestingComponent={removeSelectedTestingComponentInMultiSelect} />
            )}

            {showHideFormBySectionLabel.measurements && measurementSuggestion.length > 0 && (
              <MeasurementsSuggestion
                clearImage={clearImage}
                sectionPermission={sectionPermission}
                conversationData={conversationData}
                showGrading={showGrading}
                hideGradings={hideGradings}
                measurementSuggestion={measurementSuggestion}
              />
            )}

            {showHideFormBySectionLabel.careLabels && (
              <CareLabelsForm
                careTabs={careTabs}
                setCareTabs={setCareTabs}
                sectionPermission={sectionPermission}
                selectedType={selectedType}
                productRefBlank={productRefBlank}
                productRef={productRef}
              />
            )}

            {isFormVisible && (
              <div className="mt-16 mb-0 container-fluid">
                {/* <div className="suggestion-form"> */}
                <FormGroup className="mb-0">
                  <label htmlFor="comment" className="f-16 font-heavy">
                    {t('SUPPLIER_SUGGESTION_FORM.COMMENT')}
                  </label>
                  <textarea
                    name="comment"
                    {...register('comment', {
                      required: false,
                      maxLength: { value: 200 },
                    })}
                    onChange={(e) => {
                      setCommentCount(e.currentTarget.value.length);
                    }}
                    className="form-control custom-textarea"
                    rows="4"
                  />
                  <div className="d-flex w-100">
                    {commentCount > 200 && <small className="error-message text-left">{t('SUPPLIER_SUGGESTION_FORM.CHARACTER_LIMIT_EXCEEDED')}</small>}

                    <div className="text-right w-100">
                      <span className="text-success">{`${commentCount}/200`}</span>
                    </div>
                  </div>
                </FormGroup>
                {/* </div> */}
              </div>
            )}
          </div>
        </form>
      )}
    </FormProvider>
  );
}
export default SupplierSuggestion;
